import { HttpClient, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError, Subject, first } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { MessageModalComponent } from '../components/message-modal/message-modal.component';

type RefreshTokenResponse = {
  access: string;
  refresh: string;
};

let isRefreshing = false;
let refreshTokenSubject: Subject<any> = new Subject<any>();

export const refreshTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const http = inject(HttpClient);
  const authService = inject(AuthService);

  const dialog = inject(MatDialog);

  if (`${environment.api_url}/token/refresh/` === req.url) {
    return next(req).pipe(
      catchError((error) => {
        handleRefreshTokenError(error, authService, dialog);
        return throwError(() => new Error('refresh token dued'));
      })
    );
  }
  if (`${environment.api_url}/logout/` === req.url) {
    return next(req);
  }
  return next(req).pipe(
    catchError((error) => {
      if (error.status === 401) {
        if (!isRefreshing) {
          isRefreshing = true;
          refreshTokenSubject = new Subject<any>();

          const endpointUrl = `${environment.api_url}/token/refresh/`;

          return http.post<RefreshTokenResponse>(
            endpointUrl,
            {},
            { withCredentials: true }
          ).pipe(
            switchMap(() => {
              isRefreshing = false;
              refreshTokenSubject.next(true);

              const clonedRequest = req.clone({
                withCredentials: true,
              });

              return next(clonedRequest);
            }),
            catchError((refreshError) => {
              isRefreshing = false;
              handleRefreshTokenError(refreshError, authService, dialog);
              return throwError(() => refreshError);
            })
          );
        } else {
          return refreshTokenSubject.pipe(
            first(),
            switchMap(() => {
              const clonedRequest = req.clone({
                withCredentials: true,
              });

              return next(clonedRequest);
            })
          );
        }
      }

      return throwError(() => error);
    })
  );
};


const handleRefreshTokenError = (error: any, authService: AuthService, dialog: MatDialog) => {
  dialog.closeAll();
  dialog.open(
    MessageModalComponent,
    {
      width: '250px',
      data: {
        title: $localize`Session Expired`,
        message: $localize`Your session has expired. Please log in again to continue.`,
        confirmButtonText: $localize`Log In again`
      }
    }
  ).afterClosed().subscribe(() => {
    authService.logout();
  });
}